module.exports = __webpack_public_path__ + "media/npc_dota_hero_meepo.9d9ef6a7.webm";